
import Vue from 'vue'
import moment from 'moment'
import WeekSelector from '@/components/calendar/CalendarWeekSelector.vue'
import OfferItem from '@/components/order/CalendarOfferItem.vue'
import DailyMenuOffer from '@/model/DailyMenuOffer'
import MenuReservationItem from '@/model/MenuReservationItem'
import {Component, Prop, Watch} from "vue-property-decorator";
import {GET_MODE} from "@/store/getter-types";

@Component ({
  components: {
    WeekSelector,
    OfferItem
  }
})
export default class Calendar extends Vue {

  @Prop({type: String, required: true}) readonly isoWeek!: string
  @Prop({type: Date}) date!: Date
  @Prop({type: Array as () => DailyMenuOffer[] | null}) menuOfferCollection!: DailyMenuOffer[] | null
  @Prop({type: Array as () => MenuReservationItem[] | null}) reservationCollection!: MenuReservationItem[] | null

  private selectedDate: number | null = null

  @Watch('menuOfferCollection')
  watchMenuOfferCollection (newVal: DailyMenuOffer[]): void {
    if(newVal && this.menuOfferCollection) {
      const foundDate: DailyMenuOffer | undefined = this.menuOfferCollection.find((item: DailyMenuOffer) => moment(item.date).format('YYYY-MM-DD') === this.$route.params.date)
      if(foundDate && this.menuOfferCollection) {
        this.selectedDate = this.menuOfferCollection.indexOf(foundDate)
      }
    }
  }

  getRowColor (menuOfferItem: DailyMenuOffer): string {
    const reservationItem: any = this.findReservationItem(menuOfferItem)
    if(this.findReservationItem(menuOfferItem) && reservationItem.status === 'active') {
      return 'light-green lighten-3'
    } else if(this.findReservationItem(menuOfferItem) && reservationItem.status === 'canceled'){
      return 'red accent-1'
    } else {
      return ''
    }
  }

  get selectorIsoWeek(): string {
    return this.isoWeek
  }

  get isKioskMode (): boolean {
    return this.$store.getters[GET_MODE] === 'kiosk'
  }

  set selectorIsoWeek(newVal: string) {
    this.$emit('update:isoWeek', newVal)
  }

  findReservationItem (offerItem: DailyMenuOffer): MenuReservationItem[] | undefined {
    if (this.reservationCollection) {
      return this.reservationCollection.filter((item: MenuReservationItem) => moment(item.date).isSame(offerItem.date, 'date'))
    }
    return undefined
  }

  onChangeDate (date: string): void {
    this.$emit('update:date', new Date(date))
  }
}
